import { useCommissionComments } from 'hooks/queries/commissions/useCommissionComments';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { CommissionsComment } from 'shared/react-admin/CommissionsComment/CommissionsComment';
import { Commission } from 'types/embedded/commission';

import { CommissionsCommentSkeleton } from '../../react-admin/CommissionsComment/CommissionsCommentSkeleton';

export const CommissionsTabsComments: React.FC = () => {
  const translate = useTypedTranslate();

  const record = useRecordContext<Commission>();
  const { comments, isLoading } = useCommissionComments(record?.originId);

  if (isLoading) {
    return <CommissionsCommentSkeleton />;
  }

  return comments.length ? (
    <Box display="flex" flexDirection="column" gap="8px">
      {comments.map((comment) => (
        <RecordContextProvider key={comment.id} value={comment}>
          <CommissionsComment />
        </RecordContextProvider>
      ))}
    </Box>
  ) : (
    <Alert severity="info">{translate('app.commissions.noComments')}</Alert>
  );
};
